import React from "react";
import { motion } from "framer-motion";
import { FaCheckCircle } from "react-icons/fa";
import certificateImg from "../assets/images/course-certificate-jk-associataes.jpeg";

const benefits = [
  "Unlock professional excellence with our dynamic e-learning programs.",
  "Stand out with a professional certificate valued by employers countrywide.",
  "Bridge your skills to the perfect career with tailored training.",
  "Stay ahead of the curve with continuous upskilling and microlearning.",
  "Practical, job-ready courses that lead directly to income.",
];

const containerVariants = {
  hidden: { opacity: 0, y: 60 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: "easeOut",
      staggerChildren: 0.15,
    },
  },
};

const itemVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.4, ease: "easeOut" },
  },
};

export default function CertificateSection2() {
  const yellowText = { color: "#ffc107" };

  return (
    <section
      style={{
        padding: "80px 0",
        position: "relative",
        overflow: "hidden",
      }}
    >
      {/* Background Blur Circle */}
      <div
        style={{
          position: "absolute",
          top: "-100px",
          right: "-100px",
          width: "300px",
          height: "300px",
          borderRadius: "50%",
          background: "rgba(13, 110, 253, 0.1)",
          filter: "blur(80px)",
          zIndex: 0,
        }}
      />

      <motion.div
        className="container"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
        variants={containerVariants}
        style={{ position: "relative", zIndex: 1 }}
      >
        <div
          className="row align-items-stretch g-5"
          style={{ display: "flex", alignItems: "stretch" }}
        >
          {/* Left: Certificate Image with Blue Header */}
          <motion.div
            className="col-lg-6"
            whileHover={{ scale: 1.02 }}
            transition={{ duration: 0.3 }}
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "flex-start",
              gap: "20px",
              height: "100%",
            }}
          >
            {/* Blue Header Box */}
            <div
              style={{
                backgroundColor: "#0d6efd",
                color: "white",
                padding: "35px 30px",
                borderTopLeftRadius: "30px",
                borderTopRightRadius: "10px",
                borderBottomRightRadius: "10px",
              }}
            >
              <h3
                style={{
                  fontSize: "24px",
                  marginBottom: "15px",
                  fontWeight: "700",
                }}
              >
                Get Certified with <span style={yellowText}>Confidence</span>
              </h3>
              <p
                style={{
                  fontSize: "15px",
                  lineHeight: "1.6",
                  margin: 0,
                }}
              >
                Our certificates are industry-recognized and designed to give
                you a competitive edge. Completing our professional training
                courses awards you a certificate that validates your skills and
                knowledge.
              </p>
            </div>

            {/* Certificate Image */}
            <div
              style={{
                marginTop: "60px",
              }}
            >
              <img
                src={certificateImg}
                alt="Certificate Sample"
                style={{
                  width: "100%",
                  borderRadius: "20px",
                  boxShadow:
                    "0 12px 40px rgba(0, 0, 0, 0.15), 0 6px 20px rgba(0,0,0,0.1)",
                }}
              />
            </div>
          </motion.div>

          {/* Right: Benefits */}
          <motion.div
            className="col-lg-6"
            variants={itemVariants}
            style={{
              background: "rgba(255, 255, 255, 0.75)",
              backdropFilter: "blur(12px)",
              borderRadius: "20px",
              padding: "40px",
              boxShadow: "0 8px 30px rgba(0, 0, 0, 0.08)",
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
            }}
          >
            <motion.h2
              variants={itemVariants}
              style={{
                color: "#0d6efd",
                fontSize: "32px",
                fontWeight: "800",
                marginBottom: "25px",
                display: "inline-block",
                padding: "8px 20px",
                borderRadius: "30px",
                border: "3px solid #0d6efd",
                backgroundColor: "rgba(255,255,255,0.9)",
              }}
            >
              Why Choose Our <span style={yellowText}>Certification?</span>
            </motion.h2>

            <motion.div
              className="benefits-list"
              style={{ display: "flex", flexDirection: "column", gap: "20px" }}
            >
              {benefits.map((benefit, index) => (
                <motion.div
                  key={index}
                  variants={itemVariants}
                  whileHover={{ scale: 1.02 }}
                  style={{
                    display: "flex",
                    alignItems: "flex-start",
                    gap: "15px",
                    padding: "15px 18px",
                    background: "#fff",
                    borderRadius: "12px",
                    boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
                    fontSize: "16px",
                    fontWeight: "500",
                    color: "#333",
                  }}
                >
                  <FaCheckCircle
                    color="#0d6efd"
                    style={{ marginTop: "3px", minWidth: "20px" }}
                  />
                  {benefit}
                </motion.div>
              ))}
            </motion.div>

            {/* CTA Button */}
            <motion.div
              className="mt-4"
              whileHover={{ scale: 1.05 }}
              style={{ textAlign: "center" }}
            >
              <button
                style={{
                  background: "#0d6efd",
                  color: "#fff",
                  padding: "12px 30px",
                  fontSize: "16px",
                  fontWeight: "600",
                  border: "none",
                  borderRadius: "30px",
                  cursor: "pointer",
                  boxShadow:
                    "0 6px 20px rgba(13, 110, 253, 0.3), inset 0 0 0 0 #fff",
                  transition: "0.3s",
                }}
              >
                Download Course Outline
              </button>
            </motion.div>
          </motion.div>
        </div>
      </motion.div>
    </section>
  );
}
